import {
  LoadingPage,
  List as RaList,
  TextField,
  useQueryWithStore,
} from "react-admin";

import { Datagrid } from "ra-friendsofbabba";
import Filters from "./Filters";
import React from "react";
import { RecordInput } from "../component/input";

const List = (props) => {
  const { resource } = props;
  const layoutName = resource.replace("mir-explorer/", "");
  const { data: layout, loading } = useQueryWithStore({
    type: "get",
    resource: `mir-explorer/${layoutName}/layout`,
  });
  if (loading) {
    return <LoadingPage />;
  }
  const {
    data: { columns, filters },
  } = layout;

  return (
    <RaList
      {...props}
      perPage={25}
      filters={<Filters layoutFilters={filters} />}
      sort={{ field: "id", order: "DESC" }}
    >
      <Datagrid>
        {columns.map(({ name, editable, width }) =>
          editable ? (
            <RecordInput
              key={name}
              source={name}
              label={name}
              width={width}
              minWidth={width}
            />
          ) : (
            <TextField key={name} source={name} label={name} />
          )
        )}
      </Datagrid>
    </RaList>
  );
};
export default List;
